import { Modal } from "app/pages/activation/components/Topics/Modal/Modal";
import { translate } from "app/filters/i18nFilter";
import { FILTER_ITEMS, TOPICS_WRAPPER_ID } from "app/pages/activation/components/Topics/constants";
import { NOT_AVAILABLE_FILTER } from "app/pages/activation/components/Topics/texts";

import { useTopicsContext } from "../../context/Topics/TopicsContext";
import { useTopicsDataContext } from "../../context/Topics/TopicsDataContext";
import { TopicsModalContextProvider } from "../../context/Topics/TopicsModalContext";
import { Filters } from "../Shared/Filters/Filters";

import { topicKeys } from "./automationKeys";
import { Header } from "./Header/Header";
import { List } from "./List/List";
import { Sorting } from "./Sorting/Sorting";
import * as SC from "./styles";
import type { TopicsSchema } from "./types";
import { useTopicsParamsControl } from "./useTopicsParamsControl";

export const Topics = ({ formattedDuration, createdTopicsLength, isViewerMode = false }: TopicsSchema) => {
    const { onFilter: onClick } = useTopicsContext();
    const { flags, filter: selectedId, isDisabled } = useTopicsDataContext();

    const { initialModalData } = useTopicsParamsControl();

    return (
        <TopicsModalContextProvider
            createdTopicsLength={createdTopicsLength}
            initialModalData={initialModalData}
        >
            <Modal />

            <SC.TopicsContainer data-automation={topicKeys.container}>
                <Header
                    formattedDuration={formattedDuration}
                    isViewerMode={isViewerMode}
                />

                <SC.TopicsBody>
                    <SC.PopupWrapper id={TOPICS_WRAPPER_ID} />

                    <SC.TopicHeader data-automation={topicKeys.headerWrapper}>
                        <SC.FilterContainer data-automation={topicKeys.filterContainer}>
                            <Filters
                                items={FILTER_ITEMS}
                                selectedId={selectedId}
                                isDisabled={isDisabled}
                                flags={flags}
                                onClick={onClick}
                                disabledToolTip={translate(NOT_AVAILABLE_FILTER)}
                            />
                        </SC.FilterContainer>

                        <Sorting />
                    </SC.TopicHeader>

                    <List isViewerMode={isViewerMode} />
                </SC.TopicsBody>
            </SC.TopicsContainer>
        </TopicsModalContextProvider>
    );
};
